<template>
  <div>
    <!-- 地址 -->
    <!-- 收货地址 -->
    <baseBreadcrumb :page="$t('message.shippingAddress')" :menu="$t('message.userInfo')"></baseBreadcrumb>
    <!-- 新增按钮 -->
    <div class="add-btn">
      <el-button type="primary" @click="addAddress" v-if="isAuth(713)">{{ $t('message.add') }}</el-button>
    </div>
    <div class="addressList">
      <div class="address" v-for='(item, index) in addressList' :key='index'>
        <div class="titleName">
          {{ item.title }}
          <el-tag v-if="item.default_importer == 1" style="margin-left: 10px;">默认进口商</el-tag>
          <el-tag v-if="item.default_receiver == 1" style="margin-left: 10px;">默认收件人</el-tag>
        </div>
        <!-- 操作按钮 -->
        <div class="actions">
          <el-button size="small" @click="editAddress(item)" v-if="isAuth(713)">编辑</el-button>
          <el-button size="small" type="danger" @click="confirmDelete(item)" v-if="isAuth(714)">删除</el-button>
        </div>
        <!-- 氏名 -->
        <p>
          <span>{{ $t('message.clanName') }}:</span> <span>{{ item.name }}</span>
        </p>
        <!-- 公司名 -->
        <p>
          <span>{{ $t('message.company') }}:</span> <span>{{ item.company }}</span>
        </p>
        <!-- 会社名（ローマ字） -->
        <p>
          <span>会社名（ローマ字）:</span> <span>{{ item.company_roma }}</span>
        </p>
        <!-- 住所 -->
        <p>
          <span>{{ $t('message.domicile') }}:</span> <span :title="item.address">{{ item.address }}</span>
        </p>
        <!-- 邮编 -->
        <p>
          <span>{{ $t('message.zip_code') }}:</span> <span>{{ item.zip }}</span>
        </p>
        <!-- 手机 -->
        <p>
          <span>{{ $t('message.mobile') }}:</span> <span>{{ item.mobile }}</span>
        </p>
        <!-- 座机 -->
        <p>
          <span>{{ $t('message.tel') }}:</span> <span>{{ item.tel }}</span>
        </p>
        <!-- 法人番号 -->
        <p>
          <span>{{ $t('message.theNumberOfTheCorporation') }}:</span> <span>{{ item.corporate_name }}</span>
        </p>
        <!-- リアルタイム口座 -->
        <p>
          <span>リアルタイム口座:</span> <span>{{ item.account }}</span>
        </p>
        <!-- 標準コード -->
        <p>
          <span>標準コード:</span> <span>{{ item.standard_code }}</span>
        </p>
        <!-- 操作按钮 -->
        <div class="actions" v-if="isAuth(713)">
          <el-button size="mini" @click="setDefaultAddress(item, 'importer')">设为默认进口商</el-button>
          <el-button size="small" @click="setDefaultAddress(item, 'receiver')">设为默认收件人</el-button>

        </div>
      </div>
    </div>

    <!-- 地址编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form :model="form" label-width="120px">
        <el-form-item label="地址名称">
          <el-input v-model="form.title" placeholder="请输入地址名称"></el-input>
        </el-form-item>
        <el-form-item label="氏名">
          <el-input v-model="form.name" placeholder="请输入氏名"></el-input>
        </el-form-item>
        <el-form-item label="ローマ字(氏名)">
          <el-input v-model="form.name_rome" placeholder="请输入ローマ字(氏名)"></el-input>
        </el-form-item>
        <el-form-item label="公司名">
          <el-input v-model="form.company" placeholder="请输入公司名"></el-input>
        </el-form-item>
        <el-form-item label="会社名（ローマ字）">
          <el-input v-model="form.company_roma" placeholder="请输入会社名（ローマ字）"></el-input>
        </el-form-item>
        <el-form-item label="住所">
          <el-input type="textarea" v-model="form.address" placeholder="请输入住所"></el-input>
        </el-form-item>
        <el-form-item label="ローマ字(住所)">
          <el-input type="textarea" v-model="form.address_rome" placeholder="请输入ローマ字(住所)"></el-input>
        </el-form-item>
        <el-form-item label="邮编">
          <el-input v-model="form.zip" placeholder="请输入邮编"></el-input>
        </el-form-item>
        <el-form-item label="手机">
          <el-input v-model="form.mobile" placeholder="请输入手机"></el-input>
        </el-form-item>
        <el-form-item label="座机">
          <el-input v-model="form.tel" placeholder="请输入座机"></el-input>
        </el-form-item>
        <el-form-item label="法人番号">
          <el-input v-model="form.corporate_name" placeholder="请输入法人番号"></el-input>
        </el-form-item>
        <el-form-item label="リアルタイム口座">
          <el-input v-model="form.account" placeholder="请输入リアルタイム口座"></el-input>
        </el-form-item>
        <el-form-item label="標準コード">
          <el-input v-model="form.standard_code" placeholder="请输入標準コード"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveUserAddress">保存</el-button>
      </div>
    </el-dialog>
  </div>

</template>
<script>
export default {
  data() {
    return {
      addressList: [],
      datas: {
        user_id: this.$route.query.userID
      },
      dialogVisible: false,
      dialogTitle: '',
      form: {
        id: '',
        title: '',
        name: '',
        name_rome: '',
        company: '',
        company_roma: '',
        address: '',
        address_rome: '',
        zip: '',
        mobile: '',
        tel: '',
        corporate_name: '',
        account: '',
        standard_code: ''
      }
    };
  },
  created() {
    this.userAddressList()
  },
  methods: {
    // 获取地址列表
    userAddressList() {
      this.$api.clienteleApi.userAddressList(this.datas).then(res => {
        if (res.code != 0) return this.$message.error(res.msg)
        this.addressList = res.data
      })
    },
    // 新增地址
    addAddress() {
      this.dialogTitle = '新增地址'
      this.form = {
        user_id: this.datas.user_id,
        id: '',
        title: '',
        name: '',
        name_rome: '',
        company: '',
        company_roma: '',
        address: '',
        address_rome: '',
        zip: '',
        mobile: '',
        tel: '',
        corporate_name: '',
        account: '',
        standard_code: ''
      }
      this.dialogVisible = true
    },
    // 编辑地址
    editAddress(item) {
      this.dialogTitle = '编辑地址'
      this.form = {
        user_id: this.datas.user_id,
        id: item.id,
        title: item.title,
        name: item.name,
        name_rome: item.name_rome || '',
        company: item.company,
        company_roma: item.company_roma || '',
        address: item.address,
        address_rome: item.address_rome || '',
        zip: item.zip,
        mobile: item.mobile,
        tel: item.tel,
        corporate_name: item.corporate_name,
        account: item.account,
        standard_code: item.standard_code
      }
      this.dialogVisible = true
    },
    // 保存地址（新增/编辑）
    saveUserAddress() {
      if (this.isCompanyRomaRequired(this.form)) {
        return this.$message.error('填写公司名和法人番号时，会社名（ローマ字）必填')
      }
      const data = {
        ...this.form,
        user_id: this.datas.user_id
      }
      this.$api.clienteleApi.saveUserAddress(data).then(res => {
        if (res.code != 0) return this.$message.error(res.msg)
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.userAddressList()
      })
    },
    isCompanyRomaRequired(data) {
      return !!(data.company && data.corporate_name && !data.company_roma)
    },
    // 确认删除
    confirmDelete(item) {
      this.$confirm('确定要删除该地址吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteUserAddress({ user_id: this.datas.user_id, id: [item.id] })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    // 删除地址
    deleteUserAddress(id) {
      this.$api.clienteleApi.deleteUserAddress({ id }).then(res => {
        if (res.code != 0) return this.$message.error(res.msg)
        this.$message.success(res.msg)
        this.userAddressList()
      })
    },
    // 设置默认地址
    setDefaultAddress(item, type) {
      const data = {
        user_id: this.datas.user_id,
        default_importer: type == 'importer' ? item.id : '',
        default_receiver: type == 'receiver' ? item.id : ''
      }
      this.$api.clienteleApi.setDefaultAddress(data).then(res => {
        if (res.code != 0) return this.$message.error(res.msg)
        this.$message.success(res.msg)
        this.userAddressList()
      })
    }
  },
};
</script>
<style lang='scss' scoped>
.add-btn {
  margin: 10px;
  text-align: right;
}

.addressList {
  display: flex;
  flex-wrap: wrap;

  .address {
    background-color: #f8f8f8;
    margin: 10px;
    width: 280px;
    min-height: 300px;
    padding: 24px;
    flex-direction: column;
    display: flex;
    justify-content: space-between;

    .titleName {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    p {
      margin: 10px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        &:last-child {
          width: 50%;
        }
      }
    }

    .actions {
      display: flex;
      margin-top: 15px;
      padding-top: 15px;
      border-top: 1px solid #e8e8e8;

      button {
        flex: 1;
      }
    }
  }
}
</style>
